export enum Roles {
  isAdmin = 'isAdmin',
  VenueOwner = 'VenueOwner',
  ChildUser = 'ChildUser'
}
